module.exports = __webpack_public_path__ + "img/news-title-en.f3961e05.png";